import Constant from '@/utils/constant';

const WMRouter = Mach.requireModule('Router');

export function jumpToSelectPageAddress(data, navigateCallback?: (result: any) => void) {
  const bundleName = 'mach_pro_sailor_c_address_select_page';
  WMRouter.navigateToForResult(`${Constant.SCHEME_MACHPRO_WITH_PRE}${bundleName}`, data, navigateCallback ? (result: any) => {
  // WMRouter.navigateTo(`${Constant.SCHEME_MACHPRO_WITH_PRE}${bundleName}`, data, navigateCallback ? (result: any) => {
    if (navigateCallback) {
      navigateCallback(result);
    }
  // } : null, false);
  } : null);
}
